module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-9.v1.jpg";